import React from 'react';

import { objectOf, any } from 'prop-types';
import { BQLink } from '../../../atoms/bqlink';
import { isStoryExclusive } from '../../../../helpers/story-helpers';
import { FourStarIcon } from '../../../atoms/material-icons';

import SvgIcon from '../../../atoms/svg-icon';
import './also-read.m.css';

const AlsoRead = ({ element, story }) => {
  const linkedStoryId = element.metadata['linked-story-id'];
  if (!story['linked-stories'] || !story['linked-stories'][linkedStoryId]) return null;
  // todo: this is hotfix: if story doesn't exist in BQ. dont't show `also read` element.
  const storyUrl =
    story['linked-stories'] && '/' + story['linked-stories'][linkedStoryId].slug + '?src=also_read';
  return (
    <>
      <div className="also-read-container">
        <div className="also-read-heading">
          <span>ALSO READ</span>
        </div>
        <h3>
          <a
            className="story-element-text-also-read__link"
            href={storyUrl}
            target="_blank"
            rel="noreferrer"
          >
            {element.text}
            {isStoryExclusive(story) && (
              <span className="exclusive-icon">
                <FourStarIcon color="#CE9445" size="16px" />
              </span>
            )}
          </a>
        </h3>
      </div>
      {/* <div className="responsive-ad mobile-only">
        <DfpAd adtype="BelowAlsoReadMobile" />
      </div> */}
      <div styleName="bb-opinion-container">
        <div className="bbo-header">
          <SvgIcon
            type="bloomberg1"
            width="136"
            height="26"
            viewBox="0 0 112.479 17.347"
            iconStyle={{ fill: 'var(--first-color)' }}
          />
          <span>Opinion</span>
        </div>
        <div className="bbo-content">
          <div className="title">{element.text}</div>
          {element.description && <div className="description">{element.description}</div>}
          <div className="read-more">
            <BQLink
              className="story-element-text-also-read__link"
              href={storyUrl}
              target="_blank"
              rel="noreferrer"
            >
              Read More
            </BQLink>
          </div>
        </div>
      </div>
    </>
  );
};

AlsoRead.propTypes = {
  element: objectOf(any).isRequired,
  story: objectOf(any).isRequired
};

export default AlsoRead;
